'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const HtmlValidationMessage = ({
  message
}) => {
  return !message ? null : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: message
  });
};
HtmlValidationMessage.propTypes = {
  message: PropTypes.string
};
export default HtmlValidationMessage;